/* eslint-disable eqeqeq */

import axios from 'axios';
import moment from 'moment';
import { previousEducationReducer } from './util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

// TOOD: remove locale
moment.locale('bs');

const formatContacts = (contacts, contactTypes) => {
    const c1 = contacts.map(c => ({
        ...c,
        id: c.id,
        contactType: contactTypes.find(el => el.text == c.type) ? contactTypes.find(el => el.text == c.type).value : null,
        value: c.value
    }));
    return c1;
};

export const fetchPersonInfo = (role, contactTypes, id) => {
    if (role !== 'studentska' && (localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja'))) {
        role = 'aida';
    }
    let requestPoint;
    if (role === 'profesor') requestPoint = 'professor/personal-information/';
    if (role === 'asistent') requestPoint = 'professor/personal-information/';
    if (role === 'studentService') requestPoint = `professor/personal-information/${id}`;
    if (role === 'aida') requestPoint = `professor/personal-information-for-admin/${id}/${localStorage.getItem('orgUnit')}`;
    else if (role === 'student') requestPoint = `students/student/personal-information/localized/${window.$locale || 'bs'}`;
    else if (role === 'employee' || role === 'studentska') requestPoint = `students/student/personal-information/${id}`;
    return axios.get(requestPoint)
        .then(res => {
            const personData = res.data;
            let response = {
                ...personData,
                father: `${personData.fatherFirstName} ${personData.fatherLastName}`,
                mother: `${personData.motherFirstName} ${personData.motherLastName}`,
                dateOfBirth: moment(personData.dateOfBirth).format('D. M. YYYY.'),
                contacts: formatContacts(personData.contacts, contactTypes)
            };
            if (personData.previousEducations) {
                // append previousEducations
                response = {
                    ...response,
                    previousEducations: previousEducationReducer(personData.previousEducations)
                };
            }
            return response;
        });
};


export const fetchCurrentStudyProgramInfo = (role, studentId, studyProgramId) =>
    role === 'student' ? axios.get(`students/student/personal-information/study-program/${window.$locale || 'bs'}`)
        : axios.get(`students/student/personal-information/study-program/${studentId}/${studyProgramId}`)
            .then(res => res.data);

export const addContact = (contact, contactTypes, role, id) =>
    role === 'student' ? axios.post('/students/student/personal-information/contact', { ...contact })
        : (role === 'studentska' || role === 'profesor' || role === 'administrator') ? axios.post(`/students/student/personal-information/${id}/contact`, { ...contact })
            : role === 'hr' ? axios.post(`employees/contact/${id}/`, { ...contact }) : axios.post('/employees/contact', { ...contact });


export const deleteContact = (contactId, role, id) => {
    if (role === 'employee') return axios.delete(`/employees/delete-contact/${contactId}`);
    if (role === 'student') return axios.delete(`/students/student/personal-information/delete-contact/${contactId}`);
    if (role === 'hr') return axios.delete(`employees/contact/${contactId}`, { data: id });
    return axios.delete(`/students/student/personal-information/delete-contact/${id}/${contactId}`);
};

export default {
    fetchPersonInfo,
    fetchCurrentStudyProgramInfo,
};



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/request.js